import { useCallback, useMemo } from 'react';

import { useLazyQuoteApi } from 'Shared/services/Api';
import { useAppContext } from 'QuoteApp/services/providers/AppProvider';
import {
  GetDetailsResponseType,
  transformAppDetails,
} from 'QuoteApp/services/endpoints/GetDetails';
import { env } from 'Shared/constants/env';

export const useSetMinimumCoveragesCommand = (
  details: GetDetailsResponseType | null,
  setDetails: (details: GetDetailsResponseType) => void
) => {
  const setMinimumCoveragesCommand = useMemo(() => {
    return details?.commands?.insuranceProduct?.find(
      c => c.name === 'set_minimum_coverage_limits'
    );
  }, [details]);

  const [{ loading: pending }, setMinimumCoveragesRequest] = useLazyQuoteApi<
    GetDetailsResponseType
  >({
    url: setMinimumCoveragesCommand?.uri,
    baseURL: env.reznorHostname, // command uri already starts with '/api/v3'
    method: 'POST',
    transformResponse: transformAppDetails,
  });

  const runnable = !!setMinimumCoveragesCommand?.runnable;

  const setMinimumCoverages = useCallback(() => {
    return setMinimumCoveragesRequest().then(response => {
      setDetails(response.data);
      return response.data;
    });
  }, [setMinimumCoveragesRequest, setDetails]);

  return useMemo(() => {
    return {
      perform: setMinimumCoverages,
      pending,
      runnable,
    };
  }, [setMinimumCoverages, pending, runnable]);
};

const blankCommand = {
  runnable: false,
  perform: async () => null,
  pending: false,
};

export const useSetMinimumCoverages = () => {
  const { setMinimumCoverages } = useAppContext();

  return setMinimumCoverages || blankCommand;
};
